// extracted by mini-css-extract-plugin
export default {"anchor":"MenuItem_anchor__fqIiu","icon":"MenuItem_icon__AUjhX"};